import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
const getnavDataUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-category-data`;

// Actions
const navDataRequested = () => ({
    type: types.NAV_REQUEST
  });

const navDataSuccess = data => ({
  type: types.NAV_SUCCESS,
  data
});

const navDataFailure = error => ({
  type: types.NAV_FAILURE,
  error
});


// API
export const getnavData = (connection_id) => {
  return dispatch => {
    dispatch(navDataRequested());
    axios.get(getnavDataUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(navDataSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(navDataFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
